
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.75 12a.75.75 0 01-.75-.75v-1.5C7 8.785 7.785 8 8.75 8h1.5a.75.75 0 010 1.5h-1.5a.25.25 0 00-.25.25v1.5a.75.75 0 01-.75.75zM16.25 12a.75.75 0 01-.75-.75v-1.5a.25.25 0 00-.25-.25h-1.5a.75.75 0 010-1.5h1.5c.965 0 1.75.785 1.75 1.75v1.5a.75.75 0 01-.75.75zM10.25 18h-1.5C7.785 18 7 17.215 7 16.25v-1.5a.75.75 0 011.5 0v1.5c0 .138.112.25.25.25h1.5a.75.75 0 010 1.5zM15.25 18h-1.5a.75.75 0 010-1.5h1.5a.25.25 0 00.25-.25v-1.5a.75.75 0 011.5 0v1.5c0 .965-.785 1.75-1.75 1.75zM14.25 4h-4.5C8.785 4 8 3.215 8 2.25a.752.752 0 00-.75-.75h-.5a.75.75 0 010-1.5h.5C8.49 0 9.5 1.01 9.5 2.25c0 .138.112.25.25.25h4.5a.25.25 0 00.25-.25C14.5 1.01 15.51 0 16.75 0h.5a.75.75 0 010 1.5h-.5a.752.752 0 00-.75.75C16 3.215 15.215 4 14.25 4z"}}),_c('path',{attrs:{"d":"M17.25 24H6.75A2.752 2.752 0 014 21.25V2.75A2.752 2.752 0 016.75 0h10.5A2.752 2.752 0 0120 2.75v18.5A2.752 2.752 0 0117.25 24zM6.75 1.5c-.689 0-1.25.561-1.25 1.25v18.5c0 .689.561 1.25 1.25 1.25h10.5c.689 0 1.25-.561 1.25-1.25V2.75c0-.689-.561-1.25-1.25-1.25z"}})])
          )
        }
      }
    